import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const PinSlashSolid = t0 => {
  const $ = _c(8);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M9.5 14.5L3 21" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M5.00014 9.48521L14.1925 18.6776L15.8896 16.9805L15.788 15.9999L7.6761 7.88953L6.6972 7.78815L5.00014 9.48521Z" strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M15.1567 2.67188L21.0064 8.52156L16.6991 12.1754L11.4847 7.00046L15.1567 2.67188Z" strokeLinecap="round" strokeLinejoin="round" />;
    t4 = <path d="M3 3L21 21" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== props) {
    t5 = <IconWrapper {...props} variant="hybrid">{t1}{t2}{t3}{t4}</IconWrapper>;
    $[6] = props;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export { PinSlashSolid };